@if (!petition) {
  <app-spinner></app-spinner>
}

@if (petition) {
  <!-- POST SIGNATURE LAYOUT -->
  @if (signed) {
    <div class="post-signature-container">
      <div class="header-container">
        <div class="header">
          <div class="signed-notification">
            <div class="checkmark-container">
              <mat-icon class="green-check">check_circle</mat-icon>
            </div>
            <div class="signed-message">You signed this petition</div>
          </div>
          <div class="signatures-header"><span>{{ totalVotes }}</span>&nbsp; total signatures</div>
          <div class="title">{{ petition.title }}</div>
        </div>
      </div>
      <div class="image-and-mission">
        <div class="mission-image-container" [responsiveBackgroundImage]="petition?.active_mission?.image_url || petition?.image">
          <div class="gradient-row"></div>
          <div class="gradient-row-responsive"></div>
        </div>
        <div class="mission-box">
          <button (click)="openHelpModal()" class="help-button">
            What's a Mission?
          </button>
          <div class="mission">
            <div class="title-row">
              <img src="/assets/mission-flag.png" alt="Mission Icon">
              <div class="title">Current Mission:</div>
              <div class="subtitle">Share this post</div>
            </div>
            <div class="description-container">
              <div class="description">
                {{petition.active_mission?.post_copy || socialShareDescription}}
              </div>
            </div>
            <div class="spacer"></div>
            @if (petition.active_mission) {
              <div class="progress-row">
                <div class="progress-indicator">
                  <div class="value" [style.width]="missionProgress*100 + '%'"></div>
                </div>
                <div class="progress-text">{{progressText}}</div>
              </div>
            }
            <div class="social-buttons">
              @if (shareTargetEnabled('twitter')) {
                <button (click)="sharePetition('twitter')" class="social-btn">
                  <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path
                      d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z" />
                  </svg>
                  <div class="label">Twitter</div>
                  <div [class.completed]="checkProviderIsCompleted('twitter')" class="completion-flag">
                    <svg width="12" height="13" viewBox="0 0 12 13" xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M0.511825 0.773438C0.405903 0.773559 0.304354 0.81569 0.229455 0.890588C0.154557 0.965487 0.112426 1.06704 0.112305 1.17296V12.5675C0.112305 12.6734 0.154397 12.775 0.229323 12.85C0.304249 12.9249 0.405869 12.967 0.51183 12.967C0.617791 12.967 0.719412 12.9249 0.794337 12.85C0.869263 12.775 0.911356 12.6734 0.911356 12.5675V1.17296C0.911235 1.06703 0.869103 0.965483 0.794202 0.890584C0.719301 0.815685 0.617749 0.773555 0.511825 0.773438Z" />
                      <path
                            d="M9.95286 6.38036C9.83492 6.19795 9.77218 5.98535 9.77218 5.76813C9.77218 5.55091 9.83492 5.33832 9.95286 5.1559L11.317 3.01739C11.3994 2.89298 11.4459 2.74817 11.4511 2.59901C11.4563 2.44985 11.4202 2.30215 11.3467 2.17226C11.183 1.87384 10.8572 1.68848 10.4962 1.68848H1.21735V9.84779H10.4962C10.8572 9.84779 11.183 9.66242 11.3466 9.364C11.4202 9.23412 11.4563 9.08642 11.4511 8.93726C11.4459 8.78809 11.3994 8.64329 11.317 8.51888L9.95286 6.38036ZM8.01731 5.10488L5.85703 7.26278C5.69565 7.42398 5.47686 7.5145 5.24875 7.51444C5.02065 7.51437 4.80191 7.42373 4.64062 7.26244L3.61208 6.23388C3.49309 6.1149 3.42625 5.95352 3.42625 5.78524C3.42625 5.61697 3.49309 5.45559 3.61208 5.3366C3.67099 5.27769 3.74094 5.23095 3.81791 5.19907C3.89489 5.16718 3.9774 5.15077 4.06071 5.15077C4.14403 5.15077 4.22654 5.16718 4.30352 5.19907C4.38049 5.23095 4.45044 5.27769 4.50935 5.3366L5.05008 5.87735C5.10322 5.93049 5.17529 5.96034 5.25043 5.96034C5.32558 5.96034 5.39765 5.93049 5.45078 5.87735L7.12053 4.2076C7.17943 4.1487 7.24936 4.10198 7.32631 4.0701C7.40327 4.03822 7.48575 4.02182 7.56905 4.02182C7.65234 4.02182 7.73482 4.03822 7.81178 4.0701C7.88874 4.10198 7.95866 4.1487 8.01756 4.2076C8.07648 4.26652 8.12321 4.33647 8.15509 4.41346C8.18696 4.49045 8.20336 4.57296 8.20334 4.65629C8.20331 4.73962 8.18687 4.82212 8.15495 4.89909C8.12304 4.97606 8.07627 5.04599 8.01731 5.10488Z" />
                    </svg>
                  </div>
                </button>
              }
              @if (shareTargetEnabled('facebook')) {
                <button (click)="sharePetition('facebook')" class="social-btn">
                  <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                    <path
                      d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z" />
                  </svg>
                  <div class="label">Facebook</div>
                  <div [class.completed]="checkProviderIsCompleted('facebook')" class="completion-flag">
                    <svg width="12" height="13" viewBox="0 0 12 13" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M0.511825 0.773438C0.405903 0.773559 0.304354 0.81569 0.229455 0.890588C0.154557 0.965487 0.112426 1.06704 0.112305 1.17296V12.5675C0.112305 12.6734 0.154397 12.775 0.229323 12.85C0.304249 12.9249 0.405869 12.967 0.51183 12.967C0.617791 12.967 0.719412 12.9249 0.794337 12.85C0.869263 12.775 0.911356 12.6734 0.911356 12.5675V1.17296C0.911235 1.06703 0.869103 0.965483 0.794202 0.890584C0.719301 0.815685 0.617749 0.773555 0.511825 0.773438Z" />
                        <path
                          d="M9.95286 6.38036C9.83492 6.19795 9.77218 5.98535 9.77218 5.76813C9.77218 5.55091 9.83492 5.33832 9.95286 5.1559L11.317 3.01739C11.3994 2.89298 11.4459 2.74817 11.4511 2.59901C11.4563 2.44985 11.4202 2.30215 11.3467 2.17226C11.183 1.87384 10.8572 1.68848 10.4962 1.68848H1.21735V9.84779H10.4962C10.8572 9.84779 11.183 9.66242 11.3466 9.364C11.4202 9.23412 11.4563 9.08642 11.4511 8.93726C11.4459 8.78809 11.3994 8.64329 11.317 8.51888L9.95286 6.38036ZM8.01731 5.10488L5.85703 7.26278C5.69565 7.42398 5.47686 7.5145 5.24875 7.51444C5.02065 7.51437 4.80191 7.42373 4.64062 7.26244L3.61208 6.23388C3.49309 6.1149 3.42625 5.95352 3.42625 5.78524C3.42625 5.61697 3.49309 5.45559 3.61208 5.3366C3.67099 5.27769 3.74094 5.23095 3.81791 5.19907C3.89489 5.16718 3.9774 5.15077 4.06071 5.15077C4.14403 5.15077 4.22654 5.16718 4.30352 5.19907C4.38049 5.23095 4.45044 5.27769 4.50935 5.3366L5.05008 5.87735C5.10322 5.93049 5.17529 5.96034 5.25043 5.96034C5.32558 5.96034 5.39765 5.93049 5.45078 5.87735L7.12053 4.2076C7.17943 4.1487 7.24936 4.10198 7.32631 4.0701C7.40327 4.03822 7.48575 4.02182 7.56905 4.02182C7.65234 4.02182 7.73482 4.03822 7.81178 4.0701C7.88874 4.10198 7.95866 4.1487 8.01756 4.2076C8.07648 4.26652 8.12321 4.33647 8.15509 4.41346C8.18696 4.49045 8.20336 4.57296 8.20334 4.65629C8.20331 4.73962 8.18687 4.82212 8.15495 4.89909C8.12304 4.97606 8.07627 5.04599 8.01731 5.10488Z" />
                    </svg>
                  </div>
                </button>
              }
              @if (shareTargetEnabled('reddit')) {
                <button (click)="sharePetition('reddit')" class="social-btn" >
                  <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path
                      d="M201.5 305.5c-13.8 0-24.9-11.1-24.9-24.6 0-13.8 11.1-24.9 24.9-24.9 13.6 0 24.6 11.1 24.6 24.9 0 13.6-11.1 24.6-24.6 24.6zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-132.3-41.2c-9.4 0-17.7 3.9-23.8 10-22.4-15.5-52.6-25.5-86.1-26.6l17.4-78.3 55.4 12.5c0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.3 24.9-24.9s-11.1-24.9-24.9-24.9c-9.7 0-18 5.8-22.1 13.8l-61.2-13.6c-3-.8-6.1 1.4-6.9 4.4l-19.1 86.4c-33.2 1.4-63.1 11.3-85.5 26.8-6.1-6.4-14.7-10.2-24.1-10.2-34.9 0-46.3 46.9-14.4 62.8-1.1 5-1.7 10.2-1.7 15.5 0 52.6 59.2 95.2 132 95.2 73.1 0 132.3-42.6 132.3-95.2 0-5.3-.6-10.8-1.9-15.8 31.3-16 19.8-62.5-14.9-62.5zM302.8 331c-18.2 18.2-76.1 17.9-93.6 0-2.2-2.2-6.1-2.2-8.3 0-2.5 2.5-2.5 6.4 0 8.6 22.8 22.8 87.3 22.8 110.2 0 2.5-2.2 2.5-6.1 0-8.6-2.2-2.2-6.1-2.2-8.3 0zm7.7-75c-13.6 0-24.6 11.1-24.6 24.9 0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.1 24.9-24.6 0-13.8-11-24.9-24.9-24.9z" />
                  </svg>
                  <div class="label">Reddit</div>
                  <div [class.completed]="checkProviderIsCompleted('reddit')" class="completion-flag">
                    <svg width="12" height="13" viewBox="0 0 12 13" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M0.511825 0.773438C0.405903 0.773559 0.304354 0.81569 0.229455 0.890588C0.154557 0.965487 0.112426 1.06704 0.112305 1.17296V12.5675C0.112305 12.6734 0.154397 12.775 0.229323 12.85C0.304249 12.9249 0.405869 12.967 0.51183 12.967C0.617791 12.967 0.719412 12.9249 0.794337 12.85C0.869263 12.775 0.911356 12.6734 0.911356 12.5675V1.17296C0.911235 1.06703 0.869103 0.965483 0.794202 0.890584C0.719301 0.815685 0.617749 0.773555 0.511825 0.773438Z" />
                      <path
                        d="M9.95286 6.38036C9.83492 6.19795 9.77218 5.98535 9.77218 5.76813C9.77218 5.55091 9.83492 5.33832 9.95286 5.1559L11.317 3.01739C11.3994 2.89298 11.4459 2.74817 11.4511 2.59901C11.4563 2.44985 11.4202 2.30215 11.3467 2.17226C11.183 1.87384 10.8572 1.68848 10.4962 1.68848H1.21735V9.84779H10.4962C10.8572 9.84779 11.183 9.66242 11.3466 9.364C11.4202 9.23412 11.4563 9.08642 11.4511 8.93726C11.4459 8.78809 11.3994 8.64329 11.317 8.51888L9.95286 6.38036ZM8.01731 5.10488L5.85703 7.26278C5.69565 7.42398 5.47686 7.5145 5.24875 7.51444C5.02065 7.51437 4.80191 7.42373 4.64062 7.26244L3.61208 6.23388C3.49309 6.1149 3.42625 5.95352 3.42625 5.78524C3.42625 5.61697 3.49309 5.45559 3.61208 5.3366C3.67099 5.27769 3.74094 5.23095 3.81791 5.19907C3.89489 5.16718 3.9774 5.15077 4.06071 5.15077C4.14403 5.15077 4.22654 5.16718 4.30352 5.19907C4.38049 5.23095 4.45044 5.27769 4.50935 5.3366L5.05008 5.87735C5.10322 5.93049 5.17529 5.96034 5.25043 5.96034C5.32558 5.96034 5.39765 5.93049 5.45078 5.87735L7.12053 4.2076C7.17943 4.1487 7.24936 4.10198 7.32631 4.0701C7.40327 4.03822 7.48575 4.02182 7.56905 4.02182C7.65234 4.02182 7.73482 4.03822 7.81178 4.0701C7.88874 4.10198 7.95866 4.1487 8.01756 4.2076C8.07648 4.26652 8.12321 4.33647 8.15509 4.41346C8.18696 4.49045 8.20336 4.57296 8.20334 4.65629C8.20331 4.73962 8.18687 4.82212 8.15495 4.89909C8.12304 4.97606 8.07627 5.04599 8.01731 5.10488Z" />
                    </svg>
                  </div>
                </button>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="petition-progress-container">
        @if (petition && petition.goal) {
          <tyt-goal-progress class="only-progress-bar" [goal]="petition.goal"
          [value]="totalVotes" mode="bar" unit="signatures"></tyt-goal-progress>
        }
        @if (shouldShowReachBox) {
          <div class="reach-box">
            <div class="text">
              <div class="first-line">
                With help from supporters like you, this campaign has reached:
              </div>
              <span class="number">{{petitionMissionReachCount | number}}</span> People
            </div>
          </div>
        }
      </div>
    </div>
  }
  <div>
    <div class="signatures-header"><span>{{ actionText }}</span>&nbsp;{{ totalVotes }} Signatures</div>
    <h1 class="title">{{ petition.title }}</h1>
  </div>
  @if (!signed) {
    <div class="content-container">
      <div class="main">
        <div class="petition-image-container">
          <div class="petition-image-background" [responsiveBackgroundImage]="petition?.image"></div>
          <div class="gradient"></div>
        </div>
        @if (petition && petition.goal) {
          <tyt-goal-progress class="only-progress-bar" [goal]="petition.goal"
            [value]="totalVotes" mode="bar" unit="signatures"></tyt-goal-progress>
        }
        @if (!signed) {
          <div class="caption">{{ petitionCaption }}</div>
          @if (user?.staff) {
            <div>
              <a routerLink="/campaigns/{{petition.slug}}/edit">Edit</a>
            </div>
          }
          @if (isSigning) {
            <div class="signing-spinner">
              <div class="label">Signing petition...</div>
              <div>
                <app-spinner [inline]="true"></app-spinner>
              </div>
            </div>
          }
          @if (!isSigning) {
            <form (submit)="signPetition()">
              @if (!user && !signed) {
                <div class="visitor">
                  <div>
                    <input type="email" autocomplete="email" placeholder="* Email" class="visitor-input" name="visitorEmail"
                      required="required" (focus)="expandForm()" [(ngModel)]="visitorEmail" />
                  </div>
                  @if (showVisitorExtraFields) {
                    <div class="visitor-name">
                      <input type="text" placeholder="* First Name" autocomplete="given-name" required="required"
                        name="visitorFirstName" [(ngModel)]="visitorFirstName" />
                        <input type="text" placeholder="Last Name" autocomplete="family-name" name="visitorLastName"
                          [(ngModel)]="visitorLastName" />
                    </div>
                    <div>
                      <select [(ngModel)]="visitorCountry" name="visitorCountry" autocomplete="country">
                        <option [ngValue]="null" [disabled]="true">Select your country</option>
                        @for (country of countriesList; track country) {
                          <option [ngValue]="country.alpha2">{{ country.name }}</option>
                        }
                      </select>
                    </div>
                    <br />
                    <div class="captcha-row">
                      <re-captcha [style.display]="'inline-block'" (resolved)="captchaSolved($event)"
                      [siteKey]="recaptchaSiteKey" theme="dark"></re-captcha>
                      <span>
                        By continuing, you accept TYT's Terms of Service and Privacy Policy, and agree to receive occasional
                        emails. You can unsubscribe at any time.
                      </span>
                    </div>
                  }
                </div>
              }
              @if (visitorErrorMessage) {
                <div class="alert alert-danger">{{ visitorErrorMessage }}</div>
              }
              @if (!signed) {
                <div class="sign-petition-container">
                  <button class="petition-sign-button">Sign<img src="/assets/petitions/sign-petition.svg"></button>
                </div>
              }
            </form>
          }
          @if (petition && petition.goal) {
            <tyt-goal-progress [goal]="petition.goal" [value]="totalVotes"
              [mode]="'milestones'"></tyt-goal-progress>
          }
          @if (petition?.posts?.length > 0 || user?.staff) {
            <div class="petition-updates">
              <tyt-petition-updates [posts]="petition.posts" [pollSlug]="petition.slug" [pollId]="petition.id">
              </tyt-petition-updates>
            </div>
          }
          <h2 class="uppercase">About This Petition</h2>
          <div class="petition-description cms-content" [innerHTML]="petition.description | markdownToHtml | trustHtml"></div>
          <div class="posted-by">
            <img src="/assets/petitions/tyt-logo-white.svg">
            Posted by TYT Staff on {{ petition.opens_at | date:'shortDate' }}
          </div>
          <div>
            <tyt-content-badge
              type="petition"
              [topic]="petition.topic"
            ></tyt-content-badge>
            <tyt-comments-count [identifier]="commentIdentifier"></tyt-comments-count>
          </div>
        }
      </div>
      <div class="right-side">
        @if (signed) {
          <div class="share">
            <div class="legend"><span>Thank you for signing!</span>&nbsp;&nbsp;&nbsp;&nbsp;Share now:</div>
            <div class="content">
              <div class="content-top">
                <div class="content-image">
                  <picture responsive [src]="socialShareBoxImage"></picture>
                </div>
                <div class="content-title">{{ socialShareTitle }}</div>
              </div>
              <div class="content-description">{{ socialShareDescription }}</div>
            </div>
            <tyt-social-buttons [title]="socialShareTitle" [description]="socialShareDescription"
              [imageUrl]="socialShareImage"></tyt-social-buttons>
          </div>
        }
        @if (showEmbeddedOffers) {
          <tyt-embedded-offer-set [offerSetID]="petition.offer_set.uuid" [email]="visitorEmail"
            [firstName]="visitorFirstName" [showNoThanks]="!user"></tyt-embedded-offer-set>
        }
        <tyt-staging-note title="Tools">
          <div class="devtools">
            @if (!showEmbeddedOffers && !showEmbeddedSignUp) {
              <button mat-raised-button color="primary" (click)="setShowOffersWithoutVote()">Show Offers/Signup C2A</button>
              <em>Use this to test embedded offers without signing</em>
            }
            @if (!signed) {
              <button mat-raised-button color="primary" href="javascript:;" (click)="devAssumeSigned()">Assume Signed</button>
              <em>Use this to show the signed UI state without signing</em>
            }
            <ng-container>
              <button mat-raised-button color="primary" href="javascript:;" (click)="sendBeaconsWhileTesting()">Send "Signed" beacons</button>
              <em>
                Use this to test the beacons that are sent when a user signs a petition. NOTE: Beacons are
                usually only sent in production, this option bypasses that restriction temporarily. To
                enable beacons for your current page load even in staging/development, run
                <code>force_beacons = 1</code> in the DevTools console.
              </em>
            </ng-container>
          </div>
        </tyt-staging-note>
        @if (!signed) {
          @if (petition?.endorsements?.length > 0) {
            <div class="endorsements-module">
              <tyt-endorsements [endorsements]="petition.endorsements"></tyt-endorsements>
            </div>
          }
          <div class="recent-signers">
            <tyt-petition-recent-signers [signers]="petition.recent_activity"></tyt-petition-recent-signers>
          </div>
        }
      </div>
    </div>
  }
  @if (showEmbeddedSignUp) {
    <tyt-plus-ad-block></tyt-plus-ad-block>
  }
  @if (signed) {
    @if (!reallySigned) {
      <div class="amplify-sign-row">
        <!-- This is only shown when on the Amplify (skip signing) version of the page -->
        <a routerLink="/campaigns/{{petition.slug}}">Click here to sign this petition.</a>
      </div>
    }
    <div (click)="collapsedMoreInfo = !collapsedMoreInfo" class="collapse-row">
      @if (collapsedMoreInfo) {
        <mat-icon>chevron_right</mat-icon>
      }
      @if (!collapsedMoreInfo) {
        <mat-icon>expand_more</mat-icon>
      }
      <a href="javascript:;">{{collapsedMoreInfo ? 'Less' : 'More'}} about this campaign</a>
    </div>
    <div [class.active]="collapsedMoreInfo" [class.hidden]="!collapsedMoreInfo" class="content-container">
      <div class="main">
        <h1 class="title">{{ petition.title }}</h1>
        <div class="caption">{{ petitionCaption }}</div>
        @if (user?.staff) {
          <div>
            <a routerLink="/campaigns/{{petition.slug}}/edit">Edit</a>
          </div>
        }
        @if (isSigning) {
          <div class="signing-spinner">
            <div class="label">Signing petition...</div>
            <div>
              <app-spinner [inline]="true"></app-spinner>
            </div>
          </div>
        }
        @if (!isSigning) {
          <form (submit)="signPetition()">
            @if (!user && !signed) {
              <div class="visitor">
                <div>
                  <input type="email" autocomplete="email" placeholder="* Email" class="visitor-input" name="visitorEmail"
                    required="required" (focus)="expandForm()" [(ngModel)]="visitorEmail" />
                </div>
                @if (showVisitorExtraFields) {
                  <div class="visitor-name">
                    <input type="text" placeholder="* First Name" autocomplete="given-name" required="required"
                      name="visitorFirstName" [(ngModel)]="visitorFirstName" />
                    <input type="text" placeholder="Last Name" autocomplete="family-name" name="visitorLastName"
                      [(ngModel)]="visitorLastName" />
                  </div>
                  <div>
                    <select [(ngModel)]="visitorCountry" name="visitorCountry" autocomplete="country">
                      <option [ngValue]="null" [disabled]="true">Select your country</option>
                      @for (country of countriesList; track country) {
                        <option [ngValue]="country.alpha2">{{ country.name }}</option>
                      }
                    </select>
                  </div>
                  <br />
                  <div class="captcha-row">
                    <re-captcha [style.display]="'inline-block'" (resolved)="captchaSolved($event)"
                      [siteKey]="recaptchaSiteKey" theme="dark"></re-captcha>
                    <span>
                      By continuing, you accept TYT's Terms of Service and Privacy Policy, and agree to receive occasional
                      emails. You can unsubscribe at any time.
                    </span>
                  </div>
                }
              </div>
            }
            @if (visitorErrorMessage) {
              <div class="alert alert-danger">{{ visitorErrorMessage }}</div>
            }
            @if (!signed) {
              <div class="sign-petition-container">
                <button type="submit" class="petition-sign-button">Sign<img src="/assets/petitions/sign-petition.svg"></button>
              </div>
            }
          </form>
        }
        @if (petition && petition.goal) {
          <tyt-goal-progress [goal]="petition.goal" [value]="totalVotes"
            [mode]="'milestones'"></tyt-goal-progress>
        }
        @if (petition?.posts?.length > 0 || user?.staff) {
          <div class="petition-updates">
            <tyt-petition-updates [posts]="petition.posts" [pollSlug]="petition.slug" [pollId]="petition.id">
            </tyt-petition-updates>
          </div>
        }
        <h2 class="uppercase">About This Petition</h2>
        <div class="petition-description cms-content" [innerHTML]="petition.description | markdownToHtml | trustHtml"></div>
        <div class="posted-by">
          <img src="/assets/petitions/tyt-logo-white.svg">
          Posted by TYT Staff on {{ petition.opens_at | date:'shortDate' }}
        </div>
        <div>
          <a class="btn-tag white" routerLink="/petitions">
            Petition
          </a>
          <tyt-comments-count [identifier]="commentIdentifier"></tyt-comments-count>
          @if (petition && petition.topic) {
            <a class="btn-tag" routerLink="/topics/{{petition.topic.slug}}">
              {{petition.topic.name}}
            </a>
          }
        </div>
      </div>
      <div class="right-side">
        @if (petition?.endorsements?.length > 0) {
          <div class="endorsements-module">
            <tyt-endorsements [endorsements]="petition.endorsements"></tyt-endorsements>
          </div>
        }
        <div class="recent-signers">
          <tyt-petition-recent-signers [signers]="petition.recent_activity"></tyt-petition-recent-signers>
        </div>
      </div>
    </div>
  }
  <div class="post">
    <div class="view-more"><img src="/assets/petitions/view-more.svg">
      <a routerLink="/campaigns">&nbsp;More Petitions</a>
    </div>
    @if (enableComments) {
      <tyt-comments
        url="/campaigns/{{slug}}"
        [identifier]="commentIdentifier"
        [requirementType]="signed ? 'registration' : 'membership'"
      ></tyt-comments>
    }
    <br />
    <br />
    <tyt-staging-note title="Social Sharing">
      <div>
        <label class="key">Title: </label>
        {{socialShareTitle}}
      </div>
      <div>
        <label class="key">Image URL: </label>
        {{socialShareImage}}
      </div>
      <div>
        <label>Description: </label>
        <code>{{socialShareDescription}}</code>
      </div>
    </tyt-staging-note>
  </div>
}
